import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { faq } from '../data/site';

const FAQ = () => (
  <section id="duvidas" data-testid="faq-section" className="border-t border-line px-4 py-20 md:px-8 md:py-28">
    <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-12">
      <div className="md:col-span-4">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.14em] text-soft">Dúvidas</p>
        <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl">Perguntas frequentes.</h2>
      </div>
      <Accordion type="single" collapsible className="md:col-span-7 md:col-start-6">
        {faq.map(({ q, a }, i) => (
          <AccordionItem key={q} value={`item-${i}`} className="border-line">
            <AccordionTrigger className="py-5 text-left text-lg font-semibold hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-soft">
              {q}
            </AccordionTrigger>
            <AccordionContent className="max-w-[60ch] pb-6 text-base leading-relaxed text-soft">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
